import api from "../config/api";

export const userApi = {
  updateProfile: (data) => api.put("/user/profile", data),

  getAddresses: () => api.get("/user/addresses"),
  addAddress: (data) => api.post("/user/addresses", data),
  updateAddress: (id, data) => api.put(`/user/addresses/${id}`, data),
  deleteAddress: (id) => api.delete(`/user/addresses/${id}`),

  registerFcmToken: (token, platform) =>
    api.post("/user/fcm-token", { token, platform }),
  removeFcmToken: () => api.delete("/user/fcm-token"),

  getReferralCode: () => api.get("/user/referral-code"),
  applyReferral: (referralCode) =>
    api.post("/user/apply-referral", { referralCode }),
  getReferrals: () => api.get("/user/referrals"),

  getMilestones: () => api.get("/user/milestones"),
  redeemMilestone: (tierPoints) =>
    api.post(
      "/user/milestones/redeem",
      { tierPoints },
      {
        headers: { "X-Idempotency-Key": crypto.randomUUID() },
      },
    ),
};
